import Table from 'react-bootstrap/Table';
import {
  useDeleteSpaceRequirement,
  useGetExhibitorStallList,
} from '../../apiEndpoints/exhibitorApiEndpoints';
import moment from 'moment';
import { useEffect, useState } from 'react';
import BookYourSpace from './BookYourSpace/BookYourSpace';
import CommProfileHeader from '../CommProfileHeader';
import { Badge, Spinner } from 'react-bootstrap';
import CommonStatus from '../../../../Components/Common/CommonStatus';
import { Link, useSearchParams } from 'react-router-dom';
import PopOver from '../../../../Components/PopOver/PopOver';
import { FaEye } from 'react-icons/fa';
const SpaceRequirements = () => {
  const { data, isLoading } = useGetExhibitorStallList();
  const { mutate } = useDeleteSpaceRequirement();
  const [searchParams, setSearchParams] = useSearchParams();
  const isSpace = searchParams.get('isSpace');
  const [toggle, setToggle] = useState(false);
  useEffect(() => {
    if (isSpace) {
      setToggle(true);
    }
  }, [isSpace]);
  return (
    <div>
      <CommProfileHeader
        addHeadingTitle='Book Your Space'
        listHeadingTitle='Space Requirement List'
        createBtnText='Booked Space'
        toggle={toggle}
        setToggle={(e) => {
          setToggle(e);
          if (e) {
            setSearchParams({ isSpace: 'available' });
          } else {
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.delete('isSpace');
            setSearchParams(newSearchParams);
          }
        }}
        isMarque
      />

      {toggle ? (
        <BookYourSpace
          handleClose={() => {
            setToggle(!toggle);
          }}
        />
      ) : isLoading ? (
        <tr className='text-center'>
          <td colSpan={5}>
            <Spinner variant='primary' />
          </td>
        </tr>
      ) : (
        <div className='profile-right-side px-3 py-3'>
          <div className='profile-right-info ps-2'>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>SL.</th>
                  <th>Date</th>
                  <th>Hall Name</th>
                  <th>Stall Type</th>
                  <th>Stall No.</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{moment(item.invoice_date).format('DD-MMM-YYYY')}</td>
                    <td>{item.fair_stall_hall_name}</td>
                    <td>{item.fair_stall_type}</td>
                    <td>{item.stall_no}</td>
                    <td>{CommonStatus(item.status)}</td>
                    <td>
                      {Number(item.due) > 0 ? (
                        <Link
                          to={`/profile/view-billing-info/${item.invoice_id}`}
                          className='me-2'
                        >
                          <Badge
                            bg={'primary'}
                            text={'light'}
                            style={{
                              fontSize: '12px',
                            }}
                          >
                            {'Pay Now'}
                          </Badge>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpaceRequirements;
